export default {
    "data": {
        "h5": {
            "imgObj": {
                "top": "https://s20.lgstatic.com/growth/activity/20220315/1647315230482.png",
                "btn_main": "https://s21.lgstatic.com/growth/activity/20210915/1631689008890.png",
                "section1": "https://s20.lgstatic.com/growth/activity/20210916/1631773044640.png",
                "section2": "https://s21.lgstatic.com/growth/activity/20210916/1631777219954.png",
                "section3": "https://s20.lgstatic.com/growth/activity/20210916/1631777211368.png",
                "footer": "https://s21.lgstatic.com/growth/activity/20220426/1650954508848.png",
            },
            "imgList": [
                "https://s20.lgstatic.com/growth/activity/20210916/1631783969745.png",
                "https://s21.lgstatic.com/growth/activity/20210915/1631675044113.png",
                "https://s20.lgstatic.com/growth/activity/20210915/1631675052610.png",
                "https://s20.lgstatic.com/growth/activity/20210915/1631675061665.png",
                "https://s20.lgstatic.com/growth/activity/20210916/1631772605901.png",
            ],
            "imgList1": [
                "https://s21.lgstatic.com/growth/activity/20210915/1631690294638.png",
                "https://s21.lgstatic.com/growth/activity/20210915/1631690307528.png",
                // "https://s21.lgstatic.com/growth/activity/20210915/1631690314554.png",
                "https://s20.lgstatic.com/growth/activity/20220315/1647315261797.png?x-oss-process=style/80",
            ],
            "swiperList2": [
                "https://s20.lgstatic.com/growth/activity/20210916/1631772681606.png",
                "https://s20.lgstatic.com/growth/activity/20210916/1631772688535.png",
                "https://s20.lgstatic.com/growth/activity/20210916/1631772858283.png",
            ],
            "swiperList": [
                "https://s20.lgstatic.com/growth/activity/20210915/1631689750218.png",
                "https://s21.lgstatic.com/growth/activity/20210915/1631689770733.png",
                "https://s20.lgstatic.com/growth/activity/20210915/1631689777906.png",
                "https://s21.lgstatic.com/growth/activity/20210915/1631689784798.png",
            ],
            "swiperList1": [
                "https://s21.lgstatic.com/growth/activity/20210915/1631691095241.png",
                "https://s21.lgstatic.com/growth/activity/20210915/1631691105600.png",
                "https://s21.lgstatic.com/growth/activity/20210915/1631691112237.png",
                "https://s21.lgstatic.com/growth/activity/20210915/1631691120807.png",
                "https://s20.lgstatic.com/growth/activity/20210915/1631691127830.png",
            ],
            "swiperList3": [
                "https://s20.lgstatic.com/growth/activity/20210916/1631783982624.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631783989684.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631783996067.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631784001888.png",
            ]

        },
        "pc": {
            "imgObj": {
                "top": "https://s20.lgstatic.com/growth/activity/20220315/1647315697015.png",
                "section1": "https://s21.lgstatic.com/growth/activity/20210916/1631777323462.png",
                "section2": "https://s21.lgstatic.com/growth/activity/20210916/1631777336297.png",
                "section3": "https://s20.lgstatic.com/growth/activity/20210916/1631778356937.png",
                "section4": "https://s21.lgstatic.com/growth/activity/20210916/1631782003107.png",
                "section5": "https://s21.lgstatic.com/growth/activity/20210916/1631781995927.png",
                "btn_stage": "https://s21.lgstatic.com/growth/activity/20210916/1631778653597.png",
                "btn1": "https://s20.lgstatic.com/growth/activity/20210916/1631779326202.png",
                "logo": "https://s21.lgstatic.com/growth/activity/20220315/1647315735167.png",
                "footer": "https://s21.lgstatic.com/growth/activity/20220426/1650954542253.png",
            },
            "imgList": [
                "https://s20.lgstatic.com/growth/activity/20210916/1631774961978.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631774969388.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631774975783.png",
                "https://s20.lgstatic.com/growth/activity/20210916/1631778024551.png",
            ],
            "imgList1": [
                "https://s21.lgstatic.com/growth/activity/20210916/1631779642120.png",
                "https://s20.lgstatic.com/growth/activity/20211126/1637915707850.jpg?x-oss-process=style/80",
                "https://s20.lgstatic.com/growth/activity/20210916/1631779656394.png",
            ],
            "swiperList": [
                "https://s21.lgstatic.com/growth/activity/20210916/1631774816400.png",
                "https://s20.lgstatic.com/growth/activity/20210916/1631774823928.png",
            ],
            "swiperList1": [
                "https://s20.lgstatic.com/growth/activity/20210916/1631775063257.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631775070977.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631775077345.png",
            ],
            "swiperList2": [
                "https://s20.lgstatic.com/growth/activity/20210916/1631779015030.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631779091541.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631779100203.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631779106757.png",
            ],
            "swiperList3": [
                "https://s21.lgstatic.com/growth/activity/20210916/1631779831927.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631779838447.png ",
                "https://s20.lgstatic.com/growth/activity/20210916/1631779859778.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631779866936.png",
                "https://s20.lgstatic.com/growth/activity/20210916/1631779874015.png"
            ]
        },
        "tabList": [
            { "stage": "适用人群" },
            { "stage": "课程体系" },
            { "stage": "实战项目" },
            { "stage": "就业服务" },
            { "stage": "用户评价" },
        ],
        "stageList": [
            {
                "stage": "第一阶段",
                "title": "企业战略问题界定如何将老板的战略转换为可实施的行动 ",
                "phaseTargetList": [
                    "学习快速解决企业战略问题的经典方法论",
                    "学习如何将企业问题拆解为明确可执行的动作 学习如何科学制定可落地的项目实施计划",
                ],
                "skillsList": [
                    "如何通过麦肯锡经典的“七步成诗法”快速解决问题",
                    "如何通过SMART原则明确界定问题",
                    "如何通过决策树拆解问题",
                    "如何利用二八原则和矩阵法则抓大放小",
                ],
                "skillsContent": [
                    "业务能力：企业战略需求分析",
                    "技术能力：SMART原则，决策树，二八原则，矩阵法则",
                ],
            },
            {
                "stage": "第二阶段",
                "title": "社区团购市场分析：如何通过市场规模分析预估社区团购市场大盘",
                "phaseTargetList": [
                    "学习市场规模预测方法，了解测算当前市场与未来市场的差异及注意事项 学习搭建市场规模预测的四步法，了解不同的行业分析框架 了解社区团购行商业模式及市场集中度",
                ],
                "skillsList": [
                    "如何通过自上而下或自下而上的方式进行市场规模预测 ",
                    "如何四步搭建市场规模预测框架",
                    "了解社区团购商业模式",
                    "预测社区团购的市场规模",
                ],
                "skillsContent": [
                    "业务能力：社区团购行业规模分析框架",
                    "技术能力：excel ,mysql 、BI工具（Tableau 、PowerBi等）",
                ],
            },
            {
                "stage": "第三阶段",
                "title": "短视频行业分析：如何通过拆解产业链准确判断行业态势",
                "phaseTargetList": [
                    "学习产业链梳理方法，学习上中下游市场分析，市场供需分析",
                    "学习企业竞争力格局分析，学习拆解各企业竞争优势 学习行业未来发展预判方法，学习综合多种预判结果预估行业变化 ",
                ],
                "skillsList": [
                    "如何从0到1拆解短视频产业链构成及各环节基本态势",
                    "如何对产业链进行切分并确定重点环节",
                    "如何研究细分行业的构成和基本情况",
                    "如何科学预判行业未来发展态势 ",
                ],
                "skillsContent": [
                    "业务能力：产业链梳理、竞争模式分析",
                    "技术能力：Python爬虫 、时间序列分析",
                ],
            },
            {
                "stage": "第四阶段",
                "title": "综合视频商业分析：如何通过商业模式分析看懂内容行业",
                "phaseTargetList": [
                    "学习以爱奇艺为例的视频版权公司的业务模式，学习企业布局",
                    "学习影视剧行业的内容生态链，学习企业的内容生态建设方案",
                    "学习长视频市场分析，学习影视剧热度趋势评估方法 ",
                ],
                "skillsList": [
                    "如何从几大经典商业模式出发，看懂复杂多变的创新模式 ",
                    "如何看懂长视频行业商业模式 ",
                    "如何系统分析创新商业模式的核心要点 ",
                    "爱奇艺商业模式核心要点",
                ],
                "skillsContent": [
                    "业务能力：市场规模预估、商业模式拆解，盈利模式分析 ",
                    "技术能力：Python爬虫 、BI工具（Tableau）、波士顿矩阵、产业链图谱 ",
                ],
            },
            {
                "stage": "第五阶段",
                "title": "生鲜电商竞品分析：如何通过竞品分析突出重围、占领市场",
                "phaseTargetList": [
                    "学习竞品分析的核心流程、关键环节以及常见痛点 学习如何确定竞品并有效进行竞品信息搜集 学习如何将竞品分析提升至业务竞争的高度",
                ],
                "skillsList": [
                    "明确竞品分析的两大目的 ",
                    "八大方法找到适合自己的竞品",
                    "五层九维法掌握竞品分析核心方法论 ",
                    "竞品信息搜集的十大渠道",
                ],
                "skillsContent": [
                    "业务能力：战略层，范围层，结构层，框架层，表现层 ",
                    "技术能力：SWOT分析法，PEST分析法，波士顿矩阵，波特五力",
                ],
            },
            {
                "stage": "第六阶段",
                "title": "蔚来汽车企业研究：如何通过经营分析解决企业盈利问题 ",
                "phaseTargetList": [
                    "学习基于成本或需求的定价方法论 学习基于单品或组合产品的定价调整策略 学习四部曲解决盈利率下降问题",
                ],
                "skillsList": [
                    "如何对一个新产品定价格 ",
                    "如何对产品定价进行调整 ",
                    "如何通过定价理论对一款新型电动汽车进行定价 ",
                    "如何解决电动汽车厂商净利润率下降问题",
                ],
                "skillsContent": [
                    "业务能力：逻辑树问题拆解理论 ",
                    "技术能力：excel ,mysql 、BI工具（Tableau 、PowerBi等）",
                ],
            },
            {
                "stage": "第七阶段",
                "title": "字节教育企业研究：如何通过增长分析解决流量饥渴问题",
                "phaseTargetList": [
                    "学习日常渠道投放相关业务分析 学习如何在业务数据化程度不高的环境下走通“数据获取-数据存储-数据分析-业务改进”整个流程 学会渠道运营的优化方案，应用到自己的渠道运营优化工作上",
                ],
                "skillsList": [
                    "全国K12教育市场解析 ",
                    "全面拆解字节教育企业业务线，分析市场发展 ",
                    "企业渠道岗位业务职责介绍 ",
                    "利用核心指标分析方法解决LTV预测问题 ",
                ],
                "skillsContent": [
                    "业务能力：对整个渠道行业的判断能力，与对整个企业的渠道规划能力 ",
                    "技术能力：Python 、mysql 、BI工具（Tableau）",
                ],
            },
            {
                "stage": "第八阶段",
                "title": "腾讯课堂企业研究：如何通过运营分析解决企业收入问题",
                "phaseTargetList": [
                    "学习如何制定活动目标及拆解 学习如何设计埋点上报的数据信息 学习如何活动中指标监控及活动后复盘",
                ],
                "skillsList": [
                    "腾讯课堂平台提高收入问题拆解 策划“开学季，立flag 赢百万现金”活动 ",
                    "活动中期指标监控及预估完成情况 ",
                    "活动复盘评估活动效果 ",
                ],
                "skillsContent": [
                    "业务能力：对整个活动目标的拆解及活动策划 ",
                    "技术能力：埋点设计、excel ,mysql 、BI工具（Tableau 、PowerBi等） ",
                ],
            },
            {
                "stage": "第九阶段",
                "title": "报告制作：如何做一份麦肯锡也认可的分析报告",
                "phaseTargetList": [
                    "学习如何搭建一份分析报告的故事线 学习如何通过金字塔原理设计单页PPT 学习如何有针对性的汇报项目成果",
                ],
                "skillsList": [
                    "咨询项目中企业关心的两类诉求 ",
                    "如何分析是否应该进入一个新的行业 ",
                    "如何分析在已存在的行业中转型问题 ",
                    "K12教育培训转型策略研究分析 ",
                ],
                "skillsContent": [
                    "业务能力：问题拆解、逻辑树拆解、问题解决流程、MECE原则 ",
                    "技术能力：数据分析报告写作、报告数据可视化设计",
                ],
            },
            {
                "stage": "第十阶段",
                "title": "高质量人生 - 一个商分总监的自我修养",
                "phaseTargetList": [
                    "学习通过行业、市场分析判断企业发展方向 学习如何科学规划公司经营业务和目标管理 学习如何统筹规划企业商业分析团队 ",
                ],
                "skillsList": [
                    "企业如何通过整体数据产品的规划与设计，推进数据产品的迭代  ",
                    "如何搭建一套持续优化数据产品的用户体验业务模型  ",
                    "如何利用产品改进持续提升业务部门使用数据的效率  ",
                    "如何制订业务线数字驱动转型方案 ",
                ],
                "skillsContent": [],
            },
        ],
        projectsDetail: [
            {
                title: '项目一',
                projectTitle: '产业链分析项目',
                details: [
                    {
                        title: '项目介绍',
                        txt: '产业链拆解和市场规模预估是商业分析师研究一个行业最核心的内容，而在视频社会化趋势下，短视频平台将成为5G时代的基础设施和超级APP，而不仅限于娱乐内容平台。因此，本案例希望通过对短视频行业的研究，带大家掌握产业链拆解和行业市场规模预估的方法论，并通过以上研究对短视频行业未来发展提供一定的策略和建议。'
                    },
                    {
                        title: '核心技术',
                        txts: [
                            '业务能力：市场规模预估、商业模式拆解，盈利模式分析',
                            '技术能力：Python爬虫 、BI工具（Tableau）、波士顿矩阵、产业链图谱',
                        ]
                    }
                ],
                projectImgs: [
                    "https://s21.lgstatic.com/growth/activity/20220713/1657692892744.png",
                    "https://s21.lgstatic.com/growth/activity/20220713/1657692903292.png",
                    "https://s21.lgstatic.com/growth/activity/20220713/1657692915991.png",
                    "https://s21.lgstatic.com/growth/activity/20220713/1657692926798.png",
                ]
            },
            {
                title: '项目二',
                projectTitle: '渠道分析项目',
                details: [
                    {
                        title: '项目介绍',
                        txt: '渠道是一个企业用户增长的最重要的一环，本案例提供一个教育企业的渠道运营闭环。通过学习渠道产业的产业链，了解渠道行业中各类型渠道的特点，通过学习产品的业务模式了解企业中不同产品的用户增长需求，并通过预估产品所在的行业发展情况来规划渠道投入，在渠道投入过程中预测渠道LTV及时发现低回报渠道，调整投放策略。'
                    },
                    {
                        title: '核心技术',
                        txts: [
                            '业务能力：对整个渠道行业的判断能力，与对整个企业的渠道规划能力',
                            '技术能力：Python 、mysql 、BI工具（Tableau）',
                        ]
                    }
                ],
                projectImgs: [
                    "https://s21.lgstatic.com/growth/activity/20220713/1657692957608.png",
                    "https://s21.lgstatic.com/growth/activity/20220713/1657692971735.png",
                    "https://s21.lgstatic.com/growth/activity/20220713/1657692981354.png",
                    "https://s20.lgstatic.com/growth/activity/20220713/1657692996606.png",
                ]
            },
            {
                title: '项目三',
                projectTitle: '腾讯课堂活动策划',
                details: [
                    {
                        title: '项目介绍',
                        txt: '腾讯课堂是腾讯推出的在线教育平台，致力于用互联网的方式打破中国教育资源地域分布的不平衡。平台上聚合了大量教育机构和名师,课程包括IT互联网、设计创作、语言学习、职业考证、升学考试、生活兴趣等众多在线学习精品课程，提供一站式全方位的专业教育服务。2021年3月份开学季举行S级的营销活动"立flag, 赢百万现金"，目标是提高营业收入同比增长30%'
                    },
                    {
                        title: '技术架构',
                        txts: [
                            '业务能力：对整个活动目标的拆解及活动策划',
                            '技术能力：埋点设计、excel ,mysql 、BI工具（Tableau  、PowerBi等）',
                        ]
                    }
                ],
                projectImgs: [
                    "https://s20.lgstatic.com/growth/activity/20220713/1657693015825.png",
                    "https://s21.lgstatic.com/growth/activity/20220713/1657693029748.png",
                ]
            }
        ]
    }
}